import React from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * PerformanceDirectory: Represents the performance/mock exam/ directory structure navigation view.
 * Allows students and authorized users to browse performance results hierarchically for Mock 1 & Mock 2.
 */
const PerformanceDirectory = () => {
  const navigate = useNavigate();

  return (
    <div style={styles.container}>
      <header style={styles.header}>
        <div>
          <h1 style={styles.title}>Performance Directory</h1>
          <p style={styles.subtitle}>Current Directory: <code>performance/mock exam/</code></p>
        </div>
        <button onClick={() => navigate('/dashboard')} style={styles.btnSecondary}>
          Return to Dashboard
        </button>
      </header>

      <div style={styles.card}>
        <h2>Directory Structure</h2>
        <ul style={styles.list}>
          <li style={styles.listItem}>
            📁 <strong>mock exam /</strong>
            <ul style={{ paddingLeft: '20px', marginTop: '8px', listStyle: 'none' }}>
              <li onClick={() => navigate('/performance/mock-exam/reading-1')} style={styles.fileItem}>
                📄 <strong>reading 1</strong> (Student Results Hub — Mock Test 1)
              </li>
              <li onClick={() => navigate('/performance/mock-exam/reading-2')} style={{ ...styles.fileItem, marginTop: '10px' }}>
                📄 <strong>reading 2</strong> (Student Results Hub — Mock Test 2)
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  );
};

const styles = {
  container: { padding: '30px', fontFamily: 'Arial, sans-serif', maxWidth: '900px', margin: '0 auto' },
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '2px solid #eaeaea', paddingBottom: '20px', marginBottom: '30px' },
  title: { color: '#0056b3', margin: '0 0 5px 0' },
  subtitle: { color: '#666', margin: 0 },
  card: { border: '1px solid #ccc', padding: '25px', borderRadius: '8px', backgroundColor: '#fff', boxShadow: '0 2px 8px rgba(0,0,0,0.05)' },
  list: { listStyle: 'none', padding: 0, fontSize: '16px' },
  listItem: { padding: '10px 0' },
  fileItem: { padding: '10px 14px', background: '#f8f9fa', borderRadius: '6px', border: '1px solid #e9ecef', color: '#0056b3', display: 'block', cursor: 'pointer', fontWeight: 'bold', transition: 'background 0.2s' },
  btnSecondary: { padding: '8px 16px', background: '#6c757d', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold' }
};

export default PerformanceDirectory;